<template>
  <div>
    <vx-card
      ref="filterCard"
      :title="$t('Filters')"
      class="user-list-filters mb-8 p-4"
      collapse-action
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("FullName") }}</label>
          <vs-input
            v-model="search.Name"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("Address") }}</label>
          <vs-input
            v-model="search.Address"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">السعر من</label>
          <vs-input
            type="Number"
            v-model="search.PriceFrom"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">السعر الى</label>
          <vs-input
            type="Number"
            v-model="search.PriceTo"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">المساحة</label>
          <vs-input
            type="Number"
            v-model="search.Size"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">سنة البناء من</label>
          <vs-input
            type="Number"
            v-model="search.YearBuildFrom"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("سنة البناء الى") }}</label>
          <vs-input
            type="Number"
            v-model="search.YearBuildTo"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("الغرف من") }}</label>
          <vs-input
            type="Number"
            v-model="search.BedroomCountFrom"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("الغرف الى") }}</label>
          <vs-input
            type="Number"
            v-model="search.BedroomCountTo"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("الحمامات من") }}</label>
          <vs-input
            type="Number"
            v-model="search.BathroomCountFrom"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("الحمامات الى") }}</label>
          <vs-input
            type="Number"
            v-model="search.BathroomCountTo"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("عدد الاشخاص") }}</label>
          <vs-input
            type="Number"
            v-model="search.PersonCount"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("عدد المواقف") }}</label>
          <vs-input
            type="Number"
            v-model="search.GarageCount"
            style="margin-top: 10px;"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("اسم صاحب العقار") }}</label>
          <v-select
            label="NameAR"
            class="mt-2 w-full"
            style="margin-top: 10px;"
            name="BrokerId"
            v-model="search.BrokerId"
            :reduce="Broker => Broker.Id"
            :options="Brokers"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4" >
      <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("DateFrom") }}</label>
      <vs-input
        v-model="search.dateFrom"
        type="date"
        class="w-full"
        style="margin-top: 10px;"
      />
    </div>

    <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4" >
      <label class="text-sm opacity-75" style="font-weight:bold;">{{ $t("DateTo") }}</label>
      <vs-input
        v-model="search.dateTo"
        type="date"
        class="w-full"
        style="margin-top: 10px;"
      />
    </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-4" style="margin-top: 30px ;">
          <vs-button
            color="green"
            style="box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);font-weight: bolder;margin: 10px;width:100px"
            @click="handleSearch()"
          >{{ $t("Search") }}</vs-button>
          <vs-button
            color="red"
            style="box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);font-weight: bolder;margin: 10px;width:100px"
            @click="GoBack()"
          >{{ $t("رجوع") }}</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="card-container flex flex-wrap justify-center items-center">
      <div
        v-for="(card, index) in Propertys"
        :key="index"
        class="card bg-white shadow-lg rounded-lg p-0 m-4"
        style="width: 20%; height: 350px;"
      >
        <div class="scrolling-content flex flex-col h-full">
          <div class="img-container flex items-center justify-center" style="height: 50%;">
            <img
              v-if="card.ImagePath == null || card.ImagePath == ''"
              :src="baseURL + 'Uploads/empty-image.png'"
              class="img-thumbnail"
            />
            <img
              v-else
              :src="baseURL + '/' + card.ImagePath"
              class="img-thumbnail"
            />
          </div>
          <div class="card-header flex items-center justify-center">
            <i class="feather icon-home mr-2" style="color: #2196F3;"></i>
            <span
              class="card-heading text-xl font-bold mb-2"
              style="font-size: 10px; font-weight: bold;"
            >{{truncatedDescription( card.NameAR )}}</span>
          </div>
          <div class="card-body text-gray-700 flex-grow" title="الوصف" style="padding-right: 8px;">{{ truncatedDescription(card.DescraptionAr) }}</div>
          <div class="card-footer text-gray-500 p-2">
            <div title="الموقع" class="flex items-center">
              <i class="feather icon-map-pin mr-2" style="color: #2196F3;"></i>
              <span style="margin-right: 10px;">{{ truncatedDescription(card.AddressAR) }}</span>
            </div>
            <div class="flex items-center" style="display: inline;">
              <svg
                title="عدد الغرف"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="24"
                style="color: #2196F3;"
              >
                <path
                  title="عدد الغرف"
                  fill="currentColor"
                  d="M16 12c0-2.76-2.24-5-5-5s-5 2.24-5 5v1H2v8h2v-3h16v3h2v-8h-9v-1zM8 12c0-1.66 1.34-3 3-3s3 1.34 3 3v1H8v-1zm12 9h-2v-6H6v6H4v-4c0-1.66 1.34-3 3-3h10c1.66 0 3 1.34 3 3v4zm-8-9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                />
              </svg>
              <span v-if="card.BedroomCount>=1" title="عدد الغرف" style="margin-right: 5px; margin-left: 10px;">{{ card.BedroomCount }}</span> <span v-else title="عدد الغرف" style="margin-right: 5px; margin-left: 10px;">0</span>

              <i title="عدد الاشخاص" class="feather icon-user mr-2" style="color: #2196F3;"></i>
              <span v-if="card.PersonCount >=1" title="عدد الاشخاص" style="margin-right: 5px; margin-left: 10px;">{{ card.PersonCount }}</span><span v-else title="عدد الاشخاص" style="margin-right: 5px; margin-left: 10px;">0</span>

              <i title="عدد المشاهدات" class="feather icon-eye mr-2" style="color: #2196F3;"></i>
              <span v-if="card.ViewCount>=1" title="عدد المشاهدات" style="margin-right: 5px; margin-left: 10px;">{{ card.ViewCount }}</span><span v-else title="عدد المشاهدات" style="margin-right: 5px; margin-left: 10px;">0</span>
            </div>
            <div class="flex items-center" title="تفاصيل" style="text-align: left;">
              <vs-button
                color="#48c7da"
                class="mr-4"
                @click="openDetails(card.ID)"
                style="margin-right: auto;"
              >
                <i
                  class="feather icon-info mr-2"
                  style="color: white; font-size: 18px;"
                ></i>
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { domain } from "@/gloabelConstant.js";
import moduleProperty from "@/store/Property/moduleProperty.js";
import moduleBroker from "@/store/Broker/moduleBroker.js";

export default {
  data() {
    return {
      itemsPerPage: 10,
      isMounted: false,
      baseURL: domain,
      addNewDataSidebar: false,
      sidebarData: {},
      rowDataForDelete: {},
      activeConfirm: false,
      Brokers: [],
      search: {
        Name: "",
        Street: "",
        Descraption: "",
        DownPayment: 0.0,
        Longitude: "",
        Latitude: "",
        StreetID: 0,
        TypeID: 0,
        CategoryID: 0,
        CountryID: 0,
        ForSale: false,
        ForRent: false,
        PropertyStatusID: 0,
        PostlCode: "",
        ViewTypeID: 0,
        IsHaveRefrigerator: false,
        IsHaveHeater: false,
        IsHaveSuana: false,
        IsHaveWIFI: false,
        IsHaveTV: false,
        IsHaveMicrowave: false,
        IsHaveAirConditioner: false,
        pageNumber: 0,
        pageSize: 0,
        PropertyCategoryId: 0,
        PriceFrom: 0.0,
        Address: "",
        PriceTo: 0.0,
        Size: 0,
        YearBuildFrom: 0,
        YearBuildTo: 0,
        BedroomCountFrom: 0,
        BedroomCountTo: 0,
        BathroomCountFrom: 0,
        BathroomCountTo: 0,
        PersonCount: 0,
        GarageCount: 0,
        BrokerId: 0,
        dateFrom: "", 
       dateTo: ""  
      },
    };
  },
  computed: {
    Propertys() {
      debugger;
      return this.$store.state.PropertyList.Propertys;
    },
  },
  methods: {
    openDetails(id) {
      this.$router.push(`/CustomerProperty/PropertyDetails/${id}`);
    },
    GoBack(){
      //this.$router.go(-1);
      this.search.Address='';
      this.search. Name= "",
      this.search.Street= "",
      this.search.Descraption= "",
      this.search.DownPayment= 0.0,
      this.search.Longitude= "",
        this.search.Latitude= "",
        this.search.StreetID= 0,
        this.search.TypeID= 0,
        this.search.CategoryID= 0,
        this.search.CountryID= 0,
        this.search.ForSale= false,
        this.search.ForRent= false,
        this.search.PropertyStatusID= 0,
        this.search.PostlCode= "",
        this.search.ViewTypeID= 0,
        this.search.IsHaveRefrigerator= false,
        this.search.IsHaveHeater= false,
        this.search.IsHaveSuana= false,
        this.search.IsHaveWIFI= false,
        this.search.IsHaveTV= false,
        this.search.IsHaveMicrowave= false,
        this.search.IsHaveAirConditioner= false,
        this.search.pageNumber= 0,
        this.search.pageSize= 0,
        this.search.PropertyCategoryId= 0,
        this.search.PriceFrom= 0.0,
        this.search.Address= "",
        this.search.PriceTo= 0.0,
        this.search.Size= 0,
        this.search.YearBuildFrom= 0,
        this.search.YearBuildTo= 0,
        this.search.BedroomCountFrom= 0,
        this.search.BedroomCountTo= 0,
        this.search.BathroomCountFrom= 0,
        this.search.BathroomCountTo= 0,
        this.search.PersonCount= 0,
        this.search.GarageCount= 0,
        this.search.BrokerId= 0,
      this.$store.dispatch("PropertyList/fetchDataListItems");
    },
    truncatedDescription(description) {
      const words = description.split(' ');
      if (words.length > 5) {
        return words.slice(0, 5).join(' ') + '...';
      }
      return description;
    },
    handleSearch() {
      this.$store
        .dispatch("PropertyList/SearchPropertysData", this.search)
        .then((res) => {
          this.Propertys = res.data.data;
        });
    },
    deleteData(data) {
      this.$store.dispatch("PropertyList/removeItem", data).then(() => {
        this.$store.dispatch("PropertyList/fetchDataListItems");
      })
      .catch((err) => {
        console.error(err);
        this.$store.dispatch("PropertyList/fetchDataListItems");
      });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure you want to delete this record ?",
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      this.deleteData(this.rowDataForDelete);
      this.$vs.notify({
        time: 8000,
        color: "success",
        title: "Deleted record",
        text: "Successfully Deleted",
      });
    },
  },
  created() {
    if (!moduleProperty.isRegistered) {
      this.$store.registerModule("PropertyList", moduleProperty);
      moduleProperty.isRegistered = true;
    }
    if (!moduleBroker.isRegistered) {
      this.$store.registerModule("BrokerList", moduleBroker);
      moduleBroker.isRegistered = true;
    }
    this.$store.dispatch("BrokerList/fetchDataListItems").then((res) => {
      this.Brokers = res.data.data;
    });
    this.$store.dispatch("PropertyList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style>
.img-thumbnail {
  object-fit: cover;
  width: 123%;
  height: 100%;
}
.img-container {
  width: 100%;
  height: 50%;
}
.card {
  overflow: hidden;
}
.enhanced-search-button:hover {
  background: linear-gradient(to right, #feb47b, #ff7e5f);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
</style>
